package team.platforma.multiplatform_material_extension.ui.buttons.utils

import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import team.platforma.multiplatform_material_extension.ui.buttons.IconGravity

data class ButtonIcon(
    val painter: Painter,
    val size: Dp = 40.dp,
    val iconGravity: IconGravity = IconGravity.End,
    val attachText: Boolean = false
)